module.exports = __webpack_public_path__ + "img/iceland.1525c89.webp";